/**
 * Catálogo Completo de Serviços e Mão de Obra por Nicho MEI.
 * Solução 100% offline para aceleração do orçamento no celular.
 */

export interface ItemPresetServico {
  descricao: string;
  vUnit: number;
  unidade: string;
  tipo: 'servico' | 'material';
}

export interface CategoriaServicoMei {
  id: string;
  nome: string;
  icone: string;
  descricaoCurta: string;
  servicos: ItemPresetServico[];
}

export const CATEGORIAS_SERVICOS_MEI: CategoriaServicoMei[] = [
  {
    id: 'eletrica',
    nome: 'Elétrica',
    icone: '⚡',
    descricaoCurta: 'Instalações elétricas, quadros e iluminação',
    servicos: [
      { descricao: 'Instalação de Tomada ou Interruptor 10A/20A', vUnit: 45, unidade: 'pt', tipo: 'servico' },
      { descricao: 'Troca de Disjuntor DIN no Quadro Geral', vUnit: 80, unidade: 'un', tipo: 'servico' },
      { descricao: 'Instalação de Ponto de Iluminação LED / Plafon', vUnit: 55, unidade: 'pt', tipo: 'servico' },
      { descricao: 'Instalação ou Troca de Chuveiro Elétrico', vUnit: 90, unidade: 'un', tipo: 'servico' },
      { descricao: 'Revisão Geral e Balanceamento do Quadro de Distribuição', vUnit: 280, unidade: 'serv', tipo: 'servico' },
      { descricao: 'Instalação de Ventilador de Teto com comando', vUnit: 130, unidade: 'un', tipo: 'servico' }
    ]
  },
  {
    id: 'pintura',
    nome: 'Pintura',
    icone: '🎨',
    descricaoCurta: 'Pintura residencial, massa corrida e esmalte',
    servicos: [
      { descricao: 'Pintura de Parede 2 demãos com recorte fino', vUnit: 28, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Aplicação de Massa Corrida ou Acrílica com lixamento', vUnit: 35, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Pintura de Porta e Batente com Esmalte Sintético', vUnit: 140, unidade: 'un', tipo: 'servico' },
      { descricao: 'Pintura de Teto com Látex Fosco Anti-mofo', vUnit: 30, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Pintura de Fachada Externa com Emborrachamento', vUnit: 42, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Tratamento de Trincas e Fissuras com fita telada', vUnit: 25, unidade: 'm', tipo: 'servico' }
    ]
  },
  {
    id: 'hidraulica',
    nome: 'Hidráulica',
    icone: '🚿',
    descricaoCurta: 'Encanamento, reparos de válvulas e pias',
    servicos: [
      { descricao: 'Troca de Reparo de Válvula Hydra ou Caixa Acoplada', vUnit: 110, unidade: 'un', tipo: 'servico' },
      { descricao: 'Desentupimento de Ralo, Pia ou Vaso Sanitário', vUnit: 150, unidade: 'serv', tipo: 'servico' },
      { descricao: 'Instalação de Torneira ou Misturador Monocomando', vUnit: 75, unidade: 'un', tipo: 'servico' },
      { descricao: 'Substituição de Sifão e Engates Flexíveis com teste', vUnit: 65, unidade: 'un', tipo: 'servico' },
      { descricao: 'Localização e Reparo de Ponto de Vazamento em Tubulação', vUnit: 190, unidade: 'serv', tipo: 'servico' },
      { descricao: 'Instalação / Substituição de Caixa d’Água com conexões', vUnit: 450, unidade: 'serv', tipo: 'servico' }
    ]
  },
  {
    id: 'climatizacao',
    nome: 'Ar Condicionado',
    icone: '❄️',
    descricaoCurta: 'Instalação e higienização de splits',
    servicos: [
      { descricao: 'Higienização Completa de Split com bactericida', vUnit: 160, unidade: 'un', tipo: 'servico' },
      { descricao: 'Instalação Padrão de Ar Condicionado Split 9k-12k BTUs', vUnit: 480, unidade: 'un', tipo: 'servico' },
      { descricao: 'Carga de Gás Refrigerante R410A / R32 com vácuo', vUnit: 220, unidade: 'un', tipo: 'servico' },
      { descricao: 'Limpeza Preventiva de Turbina e Filtros', vUnit: 90, unidade: 'un', tipo: 'servico' },
      { descricao: 'Desinstalação de Split com recolhimento do gás', vUnit: 180, unidade: 'un', tipo: 'servico' }
    ]
  },
  {
    id: 'marcenaria',
    nome: 'Montagem & Móveis',
    icone: '🪚',
    descricaoCurta: 'Montagem de armários, mesas e estantes',
    servicos: [
      { descricao: 'Montagem de Guarda-Roupa Casal até 6 portas', vUnit: 230, unidade: 'un', tipo: 'servico' },
      { descricao: 'Montagem de Painel de TV com fixação e suporte', vUnit: 130, unidade: 'un', tipo: 'servico' },
      { descricao: 'Ajuste e Troca de Dobradiças e Corrediças Telescópicas', vUnit: 95, unidade: 'serv', tipo: 'servico' },
      { descricao: 'Montagem e Fixação de Armários Aéreos de Cozinha', vUnit: 280, unidade: 'serv', tipo: 'servico' },
      { descricao: 'Montagem de Mesa com Cadeiras', vUnit: 110, unidade: 'un', tipo: 'servico' }
    ]
  },
  {
    id: 'reparos',
    nome: 'Marido de Aluguel',
    icone: '🔧',
    descricaoCurta: 'Pequenos reparos, suportes e manutenções rápidas',
    servicos: [
      { descricao: 'Instalação de Suporte de TV (articulado ou fixo)', vUnit: 80, unidade: 'un', tipo: 'servico' },
      { descricao: 'Fixação de Cortinas, Persianas ou Varões', vUnit: 60, unidade: 'pt', tipo: 'servico' },
      { descricao: 'Instalação de Prateleiras, Nichos ou Quadros', vUnit: 50, unidade: 'pt', tipo: 'servico' },
      { descricao: 'Troca de Fechadura ou Maçaneta de Porta', vUnit: 90, unidade: 'un', tipo: 'servico' },
      { descricao: 'Vedação de Box de Banheiro com Silicone Anti-fungo', vUnit: 85, unidade: 'un', tipo: 'servico' },
      { descricao: 'Pacote de Pequenos Reparos até 3 horas no local', vUnit: 190, unidade: 'serv', tipo: 'servico' }
    ]
  },
  {
    id: 'reformas',
    nome: 'Obras & Gesso',
    icone: '🧱',
    descricaoCurta: 'Pisos, drywall, forros e alvenaria',
    servicos: [
      { descricao: 'Assentamento de Piso Cerâmico / Porcelanato', vUnit: 65, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Fechamento de Parede ou Divisória em Drywall', vUnit: 95, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Rebaixo de Teto em Gesso / Tabica Perimetral', vUnit: 78, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Regularização de Contrapiso Sarrafeado', vUnit: 38, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Aplicação de Rejunte Epóxi ou Cimentício', vUnit: 22, unidade: 'm²', tipo: 'servico' }
    ]
  },
  {
    id: 'limpeza',
    nome: 'Limpeza & Diária',
    icone: '🧹',
    descricaoCurta: 'Limpeza pós-obra, vidraças e pisos',
    servicos: [
      { descricao: 'Limpeza Fina Pós-Obra com remoção de respingos', vUnit: 18, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Lavagem com Alta Pressão de Calçadas e Garagens', vUnit: 12, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Limpeza de Vidraças e Janelas Blindex', vUnit: 24, unidade: 'm²', tipo: 'servico' },
      { descricao: 'Diária de Limpeza Pesada Especializada', vUnit: 240, unidade: 'dia', tipo: 'servico' }
    ]
  }
];

/**
 * Retorna uma categoria pelo ID, ou a primeira se não encontrada.
 */
export function getCategoriaServicoById(id: string): CategoriaServicoMei {
  return CATEGORIAS_SERVICOS_MEI.find(c => c.id === id) || CATEGORIAS_SERVICOS_MEI[0];
}
